// extracted by mini-css-extract-plugin
export default {"root":"E77HtH","arrowRight":"GQSgKh","arrowLeft":"tmvyt6","icon":"d2vmOV"};